import { useMutation } from "@tanstack/react-query";
import { CircleNotch, Translate } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { apiSend } from "@/lib/api-error";
import { toast } from "@/lib/toast";

export type PageTranslationResult = {
  title: string;
  content: object;
  coverImageUrl?: string | null;
  sourcePageId?: string;
};

type PageTranslateButtonProps = {
  title?: string;
  content?: object | null;
  groupId?: string;
  sourcePageId?: string;
  disabled?: boolean;
  label?: string;
  onTranslated: (translation: PageTranslationResult) => void;
};

export function PageTranslateButton({
  title,
  content,
  groupId,
  sourcePageId,
  disabled,
  label = "Prevedi na engleski",
  onTranslated,
}: PageTranslateButtonProps) {
  const hasInlineSource = !!title?.trim() && content !== null && content !== undefined;
  const hasStoredSource = !!groupId || !!sourcePageId;
  const translation = useMutation({
    mutationFn: async () =>
      apiSend<PageTranslationResult>(
        "/api/pages/translate",
        "POST",
        hasStoredSource
          ? { groupId, sourcePageId }
          : { title: title?.trim(), content },
        "Greška pri prevođenju stranice",
      ),
    onSuccess: (result) => {
      onTranslated(result);
      toast.success("Stranica je prevedena na engleski.");
    },
    onError: (err) => {
      toast.error(err instanceof Error ? err.message : "Greška pri prevođenju stranice.");
    },
  });

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="w-full justify-center"
      disabled={disabled || translation.isPending || (!hasStoredSource && !hasInlineSource)}
      onClick={() => translation.mutate()}
      title={label}
    >
      {translation.isPending ? (
        <CircleNotch className="size-3.5 animate-spin" />
      ) : (
        <Translate className="size-3.5" />
      )}
      {translation.isPending ? "Prevodi..." : label}
    </Button>
  );
}
